/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Grid,
    makeStyles,
    createStyles,
    Theme,
    Checkbox,
    FormControlLabel,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from 'react-i18next'
import { UserContext } from "../../../../contexts/AppContext";
import { PropertyTextFieldMulitline } from "../PropertyTextFieldMulitline";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left"
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        "@global": {
            ".rc-time-picker": {
                width: "100%",
                
            },
            ".rc-time-picker-input":{
                height:60,
                fontSize: 17
            }
        }
    })
);

export function StepSeven(props:any) {
    const classes = styles();  
    const {t} = useTranslation<'common'>();
    const userContext = React.useContext(UserContext);
    const SearchTypeName = props.searchTypeName;

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])
   
    return (
        <>
         
          
            <Grid container style={{ textAlign: "left" }}>
                <PropertyTextFieldMulitline
                    id="interiorRules"
                    label={`${t('label.reglements-interieurs')} :`}
                    name="rules"
                    value={props.values.rules}
                    handleChange={props.handleChange}
                    minRows={18}
                />
            </Grid >

            { SearchTypeName !== "rstt" && (
                <>
                    <div style={{width: "100%"}}>
                        <Grid container spacing={3}>
                            <Grid item lg={6} md={6} style={{flexDirection:"column", textAlign: "left"}}>
                                <label
                                    htmlFor="propertyRoomType"
                                    className={classes.inputLabel}
                                    style={{ marginBottom: 16, display: "block" }}
                                >
                                    Check-in:
                                </label>
                                <TimePicker
                                    value={props.checkin}
                                    onChange={props.handleValueChange}
                                    showSecond={false}
                                    allowEmpty
                                />
                            </Grid>
                                
                            <Grid item lg={6} md={6} style={{flexDirection:"column", textAlign: "left"}} >
                                <label
                                    htmlFor="propertyRoomType"
                                    className={classes.inputLabel}
                                    style={{ marginBottom: 16, display: "block" }}
                                >
                                    Check-out:
                                </label>
                            <TimePicker
                                value={props.checkout}
                                onChange={props.handleValueChangeOut}
                                showSecond={false}
                                allowEmpty
                            />
                            </Grid>
                        </Grid>
                    </div>
                </>
                )}
                {(SearchTypeName !== "cars" || SearchTypeName !== "cars") && ( 
                    <>       
                        <Grid container 
                        alignItems="flex-start" 
                        direction="column">
                            <Grid item style={{marginTop : 20, marginBottom: 5}}> {t('detail-annonce.animals')} ? </Grid>
                            <Grid item>
                                <RadioGroup 
                                    row
                                    aria-label="position"
                                    name = "position"
                                    defaultValue="non"
                                >
                                    <FormControlLabel
                                        value = 'oui'
                                        control={<Radio color="primary"/>}
                                        label = {t('label.oui')}
                                        labelPlacement="end"
                                        checked= {props.checkedAnimaux}
                                        onChange = {() => props.handleChangeCheckedAnimaux(true)}
                                    />
                                    <FormControlLabel
                                        value='non'
                                        control={<Radio color="primary" />}
                                        label = {t('label.non')}
                                        labelPlacement = 'end'
                                        checked= {!props.checkedAnimaux}
                                        onChange = {() => props.handleChangeCheckedAnimaux(false)}
                                    />
                                </RadioGroup>
                            </Grid>
                            <Grid item style={{marginTop : 20, marginBottom: 5}}> {t('detail-annonce.children')} ? </Grid>
                            <Grid item>
                                <RadioGroup 
                                    row
                                    aria-label="position"
                                    name = "position"
                                    defaultValue="non"
                                >
                                    <FormControlLabel
                                        value = 'oui'
                                        control={<Radio color="primary"/>}
                                        label = {t('label.oui')}
                                        labelPlacement="end"
                                        checked= {props.checkedEnfant}
                                        onChange = {() => props.handleChangeCheckedEnfant(true)}
                                    />
                                    <FormControlLabel
                                        value='non'
                                        control={<Radio color="primary" />}
                                        label = {t('label.non')}
                                        labelPlacement = 'end'
                                        checked= {!props.checkedEnfant}
                                        onChange = {() => props.handleChangeCheckedEnfant(false)}
                                    />
                                </RadioGroup>
                            </Grid>
                            <Grid item style={{marginTop : 20, marginBottom: 5}}> {t('detail-annonce.fetes')} ? </Grid>
                            <Grid item>
                                <RadioGroup 
                                    row
                                    aria-label="position"
                                    name = "position"
                                >
                                    <FormControlLabel
                                        value = 'oui'
                                        control={<Radio color="primary"/>}
                                        label = {t('label.oui')}
                                        style={{fontSize: 'inherit'}}
                                        labelPlacement="end"
                                        checked= {props.checkedFetes}
                                        onChange = {() => props.handleChangeCheckedFetes(true)}
                                    />
                                    <FormControlLabel
                                        value='non'
                                        control={<Radio color="primary" />}
                                        style={{fontSize: 'inherit'}}
                                        label = {t('label.non')}
                                        labelPlacement = 'end'
                                        checked= {!props.checkedFetes}
                                        onChange = {() => props.handleChangeCheckedFetes(false)}
                                    />
                                </RadioGroup>
                            </Grid>
                        
                
                        </Grid>
                    </>  
                )}  
        

         </>

        
    );
}
